module.exports = __webpack_public_path__ + "static/media/brand-refresh-pickup.1d035f02.svg";